import { render, staticRenderFns } from "./OverviewFinance.vue?vue&type=template&id=6bbd8965"
import script from "./OverviewFinance.vue?vue&type=script&lang=js"
export * from "./OverviewFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports